import unimoLogo from '@/assets/illustrations/unimo logo.svg'

// SiteNav's visual treatment (same padding, same logo mark) with every nav
// link and CTA stripped out — logo left, nothing else. Copy doc: "No
// navigation bar anywhere on the page."
export function LogoBar() {
    return (
        <div className="px-8 py-4 md:px-16">
            <a href="/" className="flex items-center">
                <img src={unimoLogo} alt="unimo" className="h-8 w-auto" />
            </a>
        </div>
    )
}

export default LogoBar
